@file:OptIn(ExperimentalSerializationApi::class)

package com.gsb.vyapar.bhagya.domain

import com.gsb.vyapar.bhagya.datasource.cache.CategoryEntity
import com.gsb.vyapar.bhagya.datasource.network.Dto
import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class Categories(
    val v: Int = 0,
    val d: D = D()
) {
    @Serializable
    data class D(
        val categories: List<Category> = listOf()
    ) {
        @Serializable
        data class Category(
            val id: Long = 0,
            val name: String = "",
            val imageUrl: String = "",
            val deleted: Boolean = false,
        ) {
            fun getSubCategoriesList(subCategories: SubCategories): List<SubCategories.D.SubCategory> {
                return subCategories.d.subCategories.filter { it.categoryId == id && !it.deleted }.sortedBy { it.name }
            }
        }
    }

    fun getCategoriesList(): List<Category> {
        return d.categories.filter { !it.deleted }.sortedBy { it.name }
    }
}

fun Dto.toCategories(): Categories {
    return Categories(v = v, d = ProtoBuf.decodeFromByteArray<Categories.D>(d.decodeBase64Bytes().uncompress(GZIP)))
}

fun Categories.toDto(): Dto {
    return Dto(v = v, d = ProtoBuf.encodeToByteArray(d).compress(GZIP).encodeBase64())
}

fun String.decodeCategoriesString(): Categories {
    return try {
        if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
            return Categories()
        }
        ProtoBuf.decodeFromByteArray<Categories>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        Categories()
    }
}

fun Categories.encodeCategoriesString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun CategoryEntity.toCategory(): Category {
    return Category(id, name, imageUrl, deleted)
}

fun List<CategoryEntity>.toCategoryList(): List<Category> {
    return map { it.toCategory() }
}

fun Category.toCategoryEntity(): CategoryEntity {
    return CategoryEntity(id, name, imageUrl, deleted)
}

fun List<Category>.toCategoryEntityList(): List<CategoryEntity> {
    return map { it.toCategoryEntity() }
}

fun List<Category>.toCategories(v: Int): Categories {
    return Categories(v, Categories.D(this))
}